import { authBoot as sharedAuthBoot, clearStoredTokens, decodeExp, persist, refreshWithCsrf, } from '@digiwedge/hooks-auth-web';
import { makeAuthChannel } from './auth-channel.js';
import { tryAcquireRefreshLock, releaseRefreshLock } from './auth-locks.js';
export const authBoot = sharedAuthBoot;
export { decodeExp, persist };
export function scheduleProactiveRefresh(audience, tokens, onTokens, remember, onFailure) {
    const leadMs = 30_000;
    const delay = Math.max(5_000, tokens.exp - Date.now() - leadMs);
    const handle = window.setTimeout(async () => {
        const acquired = tryAcquireRefreshLock();
        const chan = makeAuthChannel();
        try {
            if (acquired) {
                const next = await refreshWithCsrf(audience, tokens.refreshToken ? { refreshToken: tokens.refreshToken, jti: tokens.jti } : undefined);
                // Only persist/broadcast if we got actual tokens (not cookie-only { ok: true })
                if ('failed' in next) {
                    // Refresh failed - clear stale tokens and notify
                    clearStoredTokens();
                    onFailure?.();
                }
                else if ('accessToken' in next && typeof next.accessToken === 'string') {
                    persist(next, remember);
                    onTokens(next, remember);
                }
            }
            else {
                // Another tab owns refresh; wait briefly for REFRESHED broadcast
                const msg = await new Promise((resolve) => {
                    let done = false;
                    const onMsg = (e) => {
                        if (!done && e.data && e.data.type === 'REFRESHED') {
                            done = true;
                            chan.removeEventListener('message', onMsg);
                            resolve(e.data);
                        }
                    };
                    chan.addEventListener('message', onMsg);
                    setTimeout(() => {
                        if (!done) {
                            done = true;
                            chan.removeEventListener('message', onMsg);
                            resolve(undefined);
                        }
                    }, 1500);
                });
                if (msg && msg.accessToken) {
                    const next = {
                        accessToken: msg.accessToken,
                        refreshToken: msg.refreshToken,
                        jti: msg.jti,
                        exp: msg.exp,
                    };
                    persist(next, remember);
                    onTokens(next, remember);
                }
            }
        }
        finally {
            if (acquired)
                releaseRefreshLock();
            try {
                chan.close();
            }
            catch {
                /* ignore */
            }
        }
    }, delay);
    return () => window.clearTimeout(handle);
}
//# sourceMappingURL=auth-boot.js.map